import { Component, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators, ValidatorFn, AbstractControl } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { NgSelectComponent } from '@ng-select/ng-select';
import { finalize } from 'rxjs';
import { ApiService } from 'src/app/services/api/api.service';
import { ErrorModalComponent } from 'src/app/shared/modals/error-modal/error-modal.component';
import { SuccessModalComponent } from 'src/app/shared/modals/success-modal/success-modal.component';
import { IgrAssessmentAsinVerificationModalComponent } from '../../igr-services/igr-assessment/igr-assessment-asin-verification-modal/igr-assessment-asin-verification-modal.component';
import { ConfirmActionComponent } from 'src/app/shared/components/confirm-action/confirm-action.component';

@Component({
  selector: 'app-generate-coupon-modal',
  standalone: false,
  templateUrl: './generate-coupon-modal.component.html',
  styleUrl: './generate-coupon-modal.component.scss'
})
export class GenerateCouponModalComponent {
  form!: FormGroup;
  isVerifyingPaymentReference: boolean;
  isSubmitting: boolean = false;
  isSubmitAttempted: boolean = false;
  isLoading: boolean = false;
  showErrorMessages: boolean = false;


  constructor(
    private dialog: MatDialog,
    private router: Router,
    private fb: FormBuilder,
    public dialogRef: MatDialogRef<GenerateCouponModalComponent>,
    @Inject(MAT_DIALOG_DATA) public editModeData: any,
    private apiService: ApiService
  ) { }

  ngOnInit(): void {
    this.initForm();

  }



  initForm(): void {
    this.form = this.fb.group({
      email: [
        '',
        [Validators.required, Validators.maxLength(40), this.emailValidator()],
      ],
      paymentReference: ['', [Validators.required, Validators.maxLength(100)]],
      amount: ['', [Validators.required, Validators.maxLength(60)]],
      paymentDate: ['', [Validators.required, Validators.maxLength(60)]],

    });

    this.form.get('paymentReference')?.valueChanges.subscribe(value => {
      if (value && value.trim() !== '') {
        this.form.patchValue({
          amount: '',
          paymentDate: ''
        });
      }
    });
  }

  emailValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } | null => {
      const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

      if (control.value && !emailPattern.test(control.value)) {
        return { invalidEmail: true };
      }

      return null;
    };
  }


  generateCoupon() {

    this.isSubmitting = true;

    let req = {

      paymentReference: this.form.get('paymentReference')?.value,
      email: this.form.get('email')?.value

    }

    this.apiService
      .post('/reconciliation/create/coupon', req)
      .pipe(
        finalize(() => {
          this.isSubmitting = false;
        })
      )
      .subscribe(
        (response: any) => {

          this.openSuccessModal("Code: " + response?.couponCode)

        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );
  }

  verifyPaymentReference() {

    this.isVerifyingPaymentReference = true;

    let req = {

      paymentReference: this.form.get('paymentReference')?.value

    }

    this.apiService
      .post('/reconciliation/payment/search/coupon', req)
      .pipe(
        finalize(() => {
          this.isVerifyingPaymentReference = false;
        })
      )
      .subscribe(
        (response: any) => {


          const formattedAmount = response?.paymentAmount != null ? '₦' + (Number(response?.paymentAmount) * 2).toLocaleString('en-US'): '';
          this.form.patchValue({
            amount: formattedAmount,
            paymentDate: response?.paymentDate,

          });

        },
        (error) => {
          this.openErrorModal(error?.message);
        }
      );
  }

  openPaymentReferenceVerificationModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => { });
  }

  openSuccessModal(message: string) {
    let dialogRef = this.dialog.open(SuccessModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { successMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {
      location.reload()
    });
  }


  openErrorModal(message: string) {
    let dialogRef = this.dialog.open(ErrorModalComponent, {
      width: '350px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'modal-no-overflow-changed'],
      data: { errorMessage: message },
    });

    dialogRef.afterClosed().subscribe(() => {

    });
  }

  openConfirmModal() {
    this.dialog.open(ConfirmActionComponent, {
      width: '400px',
      backdropClass: 'modal-form-backdrop',
      hasBackdrop: true,
      panelClass: ['modal-form', 'operation-modal', 'modal-no-overflow-changed'],
      disableClose: true,

      data: {
        title: 'Generate Coupon?',
        body: '',
        confirmText: 'Yes',
        lottieIconPath: 'assets/lottie/alert.json',
        onConfirm: () => {
          this.generateCoupon();
        },
        onCancel: () => { },
        showCancelButton: true,
        showConfirmButton: true,
      },
    });
  }



  closeModal(): void {
    this.form.reset();
    this.dialogRef.close();
  }




}